import styled from "styled-components";
import Colors from "../../../../../../constants/Colors";

interface TextProps {
  color?: string;
  bold?: boolean;
  textAlign?: string;
}

export const Container = styled.div<{ isMobile?: boolean }>`
  margin-bottom: 50px;
`;
export const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* padding: 16px 16px; */
  padding: 0px 20px;
  gap: 16px;
  flex-wrap: wrap;

  width: 94%;

  background: ${Colors.SPM50};
  box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.1),
    0px 1px 3px rgba(16, 24, 40, 0.1);
  border-radius: 8px;

  margin-bottom: 10px;
`;
export const BoxStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
export const BoxIcons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px;
`;
export const Text = styled.p<TextProps>`
  word-break: break-word;
  color: ${(props) => (props.color ? props.color : Colors.GRAY900)};
  font-size: 16px;
  font-weight: ${(props) => (props.bold ? "bold" : "")};
  font-family: "Inter", sans-serif;
  text-align: start;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  width: 100px;
`;
export const Status = styled.button`
  padding: 4px 8px;

  width: 200px;
  height: 35px;
  gap: 16px;

  background: ${Colors.ORANGE500};
  color: ${Colors.WHITE};
  border-radius: 8px;
  pointer-events: none;
  border: none;
  font-family: 'Inter', sans-serif;
`;

export const Icon = styled.img<{ width: number; height: number }>`
  width: ${(props) => props.width + "px"};
  height: ${(props) => props.height + "px"};
  cursor: pointer;
`;
